import { MenuItem, Select } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";

const OptionAddon = ({ data, handleChange, index, addRow, deleteRow }) => {
  const [state, setState] = useState({
    addons: data,
  });
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    setState({ addons: data });
  }, [data]);

  // useEffect(() => {
  //   handleChange(state.addons, "personal_information");
  // }, [isChange]);

  // const addRow = (e) => {
  //   e.preventDefault();
  //   setState((pre) => ({
  //     ...pre,
  //     addons: [...pre.addons, ""],
  //   }));
  // };

  // const deleteRow = (e, index) => {
  //   e.preventDefault();
  //   const addons = state.addons.filter((e, i) => i !== index);
  //   setState({
  //     addons: [...addons],
  //   });
  //   setIsChange(!isChange);
  // };

  return (
    <>
      {data &&
        data.map((s, i) => {
          return (
            <div className="my-2">
              <Row className="align-items-center option-field-input">
                <Col md={8} className="range-inner">
                  <label htmlFor="title">Title</label>
                  <input
                    type="text"
                    name="title"
                    value={s.title}
                    onChange={(e) => handleChange(e, index, i)}
                    placeholder=""
                    className="form-control"
                  />
                </Col>

                {/* {i ? ( */}
                <div className="col-md-4 text-end pt-4">
                  <button
                    className="remove-btn address-btn-remove address-remove position-relative"
                    onClick={(e) => deleteRow(e, index, i)}
                  >
                    Remove
                  </button>
                </div>
                {/* ) : (
                  ""
                )} */}
              </Row>
            </div>
          );
        })}

      <div className="expension-btn text-left">
        <button
          type="button"
          className="expension-button add-option-btn text-center mb-3"
          data-toggle="modal"
          data-target="#exampleModalScrollable1"
          onClick={(e) => addRow(e, index)}
        >
          Add Option
        </button>
      </div>
    </>
  );
};

export default React.memo(OptionAddon);
